import { MutableRefObject, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { OctagonButton } from "@/common/buttons";
import { InlineDiv } from "@/common/divs";
import { InputWithNoBorder } from "@/common/inputs";

import {
  PRIMARY_BRAND_VARIANT_COLOR,
  PRIMARY_BUTTON_COLOR,
  PRIMARY_BUTTON_COLOR_DISSABLED,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";

interface SeatsInputProps {
  min: number;
  max: number;
  extraSeats: string;
  setExtraSeats: (value: string) => void;
  extraPrice: MutableRefObject<number>;
  linePrice: number;
}
const ExtraSeats: React.FC<SeatsInputProps> = ({
  min,
  max,
  extraSeats,
  setExtraSeats,
  extraPrice,
  linePrice,
}) => {
  useEffect(() => {
    extraPrice.current = parseInt(extraSeats) * linePrice;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extraSeats]);
  const handleChangePersonas = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === "") {
      setExtraSeats(event.target.value);
    }
    if (
      parseInt(event.target.value) >= min &&
      parseInt(event.target.value) <= max
    ) {
      setExtraSeats(event.target.value);
    }
  };

  const handleIncrement = () => {
    if (extraSeats == "") {
      setExtraSeats("1");
    }
    if (parseInt(extraSeats) < max) {
      setExtraSeats((parseInt(extraSeats) + 1).toString());
      //@ts-ignore
    }
  };

  const handleDecrement = () => {
    if (parseInt(extraSeats) > min) {
      setExtraSeats((parseInt(extraSeats) - 1).toString());
      //@ts-ignore
    }
  };
  const getBorderColor = (simbol: string) => {
    if (simbol === "+") {
      if (extraSeats === max.toString()) {
        return PRIMARY_BUTTON_COLOR_DISSABLED;
      } else {
        return PRIMARY_BUTTON_COLOR;
      }
    } else {
      if (extraSeats === min.toString() || extraSeats === "") {
        return PRIMARY_BUTTON_COLOR_DISSABLED;
      } else {
        return PRIMARY_BUTTON_COLOR;
      }
    }
  };

  const getBackgroundColor = (simbol: string) => {
    if (simbol === "+") {
      if (extraSeats === max.toString()) {
        return SECONDARY_BUTTON_COLOR;
      } else {
        return PRIMARY_BRAND_VARIANT_COLOR;
      }
    } else {
      if (extraSeats === min.toString() || extraSeats === "") {
        return SECONDARY_BUTTON_COLOR;
      } else {
        return PRIMARY_BRAND_VARIANT_COLOR;
      }
    }
  };
  return (
    <InlineDiv style={{ alignItems: "center" }}>
      <OctagonButton
        style={{
          borderRadius: "50px",
          border: "1px solid " + getBorderColor("-"),
        }}
        width="24px"
        height="24px"
        backgroundColor={getBackgroundColor("-")}
        onClick={() => {
          handleDecrement();
        }}
      >
        <RemoveIcon fontSize="small" style={{ color: getBorderColor("-") }} />
      </OctagonButton>
      <InputWithNoBorder
        type="number"
        className="personas-input"
        placeholder="1"
        name="personas-extra"
        value={extraSeats}
        onChange={(e) => {
          handleChangePersonas(e);
        }}
      />
      <OctagonButton
        style={{
          borderRadius: "50px",
          border: "1px solid " + getBorderColor("+"),
        }}
        width="24px"
        height="24px"
        backgroundColor={getBackgroundColor("+")}
        onClick={() => {
          handleIncrement();
        }}
      >
        <AddIcon fontSize="small" style={{ color: getBorderColor("+") }} />
      </OctagonButton>
    </InlineDiv>
  );
};

export default ExtraSeats;
